export default __webpack_public_path__ + "static/media/p.ff3f5504.svg";